
<template>
  <div class="list_home">
    <div class="top_title">{{titleName}}</div>
    <div class="list-box">
      <div
        class="item"
        v-for="(item, index) in data"
        :key="index"
        @click="onItemClick(item)"
      >
        <div class="tit">{{item.title}}</div>
        <div class="bottom">
          <span>{{$moment(item.create_time)}}</span>
          <div class="right">
            <Icon type="ios-eye" color:='#aaa' size='26' />
            <span style="margin-left: 8px">{{item.see}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  inject:  ['reload'],
  data() {
    return {
      active: 0,
      titleName:'',
      parentId:0,
      data:[],
      catId:'',
      search:''
    };
  },
  mounted() {
    this.catId = this.$route.query.cat;
    this.titleName = this.$route.query.title;
    this.parentId = this.$route.query.parentId;

    this.search = this.$route.params.search;

    this.getData();
  },
  methods: {
    ...mapActions(["GetDocs"]),
    getData() {
      this.GetDocs({l:30,cat0:this.parentId,cat1:this.catId,keyword:this.search,status: 0 }).then((res) => {
        this.data = res.data;
      });
    },
    onItemClick(data) {
      this.$router.push({path: "/help/info", query: {id:data.id,catId:this.catId}});
    },
  },
};
</script>
<style lang="less">
@import "./index.less";
</style>
